import React from 'react';
import '../addRegion/addRegion.css';
import axios from 'axios';
import baseConfig from '../../../config/config';
import { useNavigate } from "react-router-dom";

function EditGpu(props) {
    const [selectedArray, setSelectedArray] = React.useState(props.data.data);
    const [availableGPU, setAvailableGPU] = React.useState(props.data.data.Total || '');
    const [errorMessage, setErrorMessage] = React.useState("");
    function showToast(message, status) {
        const toaster = document.createElement('div');
        toaster.className = `toaster ${status}-toaster`;
        toaster.style.position = 'fixed';
        toaster.style.top = '5%';
        toaster.style.left = '50%';
        toaster.style.transform = 'translateX(-50%)';

        toaster.style.height = '35px';
        toaster.style.maxWidth = '300px';
        toaster.style.zIndex = 1000;
        toaster.innerText = message;

        document.body.appendChild(toaster);
        setTimeout(() => {
            toaster.style.display = 'none';
        }, 5000);
    }

    const update = async () => {
        if (props.type !== 'gpu') {
            selectedArray.ModelID = props.header
        }
        const postData = {
            Region: selectedArray.Region,
            GPUName: props.header,
            AvailableGPU: availableGPU === '' ? 0 : parseInt(availableGPU, 10) 
        };
        const url = '/available/gpu/edit';
        try {
            let csrfToken=localStorage.getItem("csrfToken")
            const response = await axios.post(
                baseConfig.apiBaseUrl + url,
                postData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        "serviceid": sessionStorage.getItem("userToken"),
                        "X-CSRF-Token": csrfToken
                    },
                    withCredentials: true,
                }
            );

            if (response.status === 200) {
                props.handleModal()
                showToast(response.data, "success");
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            }
        } catch (error) {
            console.error('API Error:', error);
        }
    }
    const closeModal = () => {
        props.handleModal()
    }

    const handleInputChange = (e) => {
        const newValue = e.target.value;

        if (newValue === '') {
            setErrorMessage(''); 
        } else {
            const parsedValue = parseInt(newValue, 10);
            
            if (isNaN(parsedValue)) {
                setErrorMessage("Please enter a valid number");
            } else if (parsedValue < 0) {
                setErrorMessage("Total GPU cannot be negative");
            } else if (parsedValue % 8 !== 0) {
                setErrorMessage("Total GPU must be a multiple of 8 ");
            } else {
                setErrorMessage('');
            }
        }

        setAvailableGPU(newValue);
    };

    const isSubmitDisabled = () => {
        if (availableGPU === '') return true;
        
        const parsedValue = parseInt(availableGPU, 10);
        if (isNaN(parsedValue) || parsedValue < 0 || parsedValue % 8 !== 0) {
            return true;
        }
        
        return false;
    };

    return (
        <div className="modal-container-add " style={{ width: 'fit-content' }}>
            <div style={{ maxHeight: '80vh' }}>
                <div className="title-add">
                    {props.type === 'gpu' ? <b>Edit Total GPU</b> : <b>Edit Total GPU</b>}
                    <i className="fa fa-times close-icon" onClick={closeModal}></i>
                </div>

                <hr className="divider-add" />

                <div className="grid-container-add">
                    <div className="grid-item-add" style={{ flexBasis: '2.4%', fontSize: '14px', marginBottom: '0px', paddingRight: '20px' }}>
                        <div className="input-container-add">
                            <label className="text-container-add">Region Name</label>
                            <input
                                type="text"
                                disabled
                                value={selectedArray?.Region}
                                className="custom-input-add disabled"
                            />
                        </div>
                    </div>

                    <div className="grid-item-add" style={{ flexBasis: '2.4%', fontSize: '14px', marginBottom: '0px', paddingRight: '20px' }}>
                        <div className="input-container-add">
                        <label className="text-container-add">Total GPU</label>
                            <input
                                type="number"
                                onWheel={(e) => e.target.blur()}
                                onKeyDown={(e) => {
                                  if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                    e.preventDefault();
                                  }
                                }}
                                value={availableGPU}
                                placeholder="Enter number multiple of 8 "
                                className="custom-input-add"
                                onChange={handleInputChange}
                            />
                            {errorMessage && <p style={{ color: 'red', fontSize: '12px' }}>{errorMessage}</p>}
                        </div>
                    </div>
                </div>

                <hr className="divider-add" />
                <div className="buttons-container-add marginBottom">
                    <button
                        className="button-add button-go-back-add"
                        onClick={closeModal}
                    >
                        Cancel
                    </button>
                    <button
                        className="button-add button-confirm-add"
                        onClick={update}
                        disabled={isSubmitDisabled()}
                    >
                        Submit
                    </button>
                </div>
            </div>
        </div >
    );
}

export default EditGpu;